module.exports = __webpack_public_path__ + "media/images/login-bg-b0238de1a5ba47516575e47122ceadf1.jpg";